module.exports = __webpack_public_path__ + "img/1_x7.9546b174.png";